import Icon from '../components/Icon.vue'

Icon.register({
  cocktail: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M296 464H240V338.8L408.7 170C424.3 154.5 413.3 128 391.3 128H24.7C2.7 128-8.3 154.5 7.3 170L176 338.8V464H120C97.9 464 80 481.9 80 504 80 508.4 83.6 512 88 512H328C332.4 512 336 508.4 336 504 336 481.9 318.1 464 296 464zM432 0C369.4 0 316.6 40.2 296.8 96H349.4C366 67.4 396.6 48 432 48 484.9 48 528 91.1 528 144S484.9 240 432 240C418 240 404.7 236.8 392.7 231.4L357.4 266.6C379.2 279.9 404.6 288 432 288 511.5 288 576 223.5 576 144S511.5 0 432 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cocktail.js
// module id = SKiW
// module chunks = 144